export const useRadioGroupContextValues = state => {
  const {
    name,
    value,
    defaultValue,
    disabled,
    layout,
    required
  } = state;
  const radioGroup = {
    name,
    value,
    defaultValue,
    disabled,
    layout,
    required
  };
  return {
    radioGroup
  };
};
//# sourceMappingURL=useRadioGroupContextValues.js.map